import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  onBreak: { id: 'dashboard.todayTeam.onBreak', defaultMessage: 'Na przerwie' },
  present: { id: 'dashboard.todayTeam.present', defaultMessage: 'Obecny na zmianie' },
});
